/**
 * Support case API — tenant-facing.
 */
import { http } from './client';

export interface SupportCase {
  id: string;
  category: string;
  subject: string;
  description?: string;
  priority: string;
  status: string;
  resolved_at?: string | null;
  created_at: string | null;
  updated_at?: string | null;
  replies?: SupportCaseReply[];
}

export interface SupportCaseReply {
  id: string;
  author_role: 'tenant' | 'admin';
  author_id?: string;
  author_name: string | null;
  message: string;
  created_at: string | null;
}

export interface SupportCaseSubmit {
  category: string;
  subject: string;
  description: string;
  priority: 'low' | 'normal' | 'high' | 'urgent';
}

export const supportApi = {
  list: (params?: { page?: number; page_size?: number; status?: string }) =>
    http.get<{
      items: SupportCase[];
      total: number;
      page: number;
      page_size: number;
    }>('/v1/support/cases', { params }),

  get: (caseId: string) =>
    http.get<SupportCase>(`/v1/support/cases/${caseId}`),

  create: (body: SupportCaseSubmit) =>
    http.post<SupportCase>('/v1/support/cases', body),

  reply: (caseId: string, message: string) =>
    http.post<SupportCaseReply>(
      `/v1/support/cases/${caseId}/replies`,
      { message },
    ),

  /**
   * Tenant-initiated close. Distinct from admin's resolve action —
   * tenant says "no longer needed". Status flips to 'closed' and
   * an audit reply is auto-posted to the thread. Backend refuses
   * with 409 when status is already 'closed'.
   */
  close: (caseId: string) =>
    http.post<SupportCase>(`/v1/support/cases/${caseId}/close`),
};
